import { Client } from '@microsoft/microsoft-graph-client';

export async function getUserGroups(accessToken: string) {
    console.debug('GraphService.getUserGroups()');
    
    const client = Client.init({ authProvider: done => done(null, accessToken) });
    return await client.api('/me/memberOf').get();
}
